import { useTheme } from "@material-ui/core";
import { isEmpty, isNil } from "lodash";
import * as React from "react";
import {
  LineChart,
  Line,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

// const valor = {
//   showX: true,
//   showY: true,
//   showTooltip: true,
//   lines: ["Euro", "Dolar"],
//   lineColors: ["#F5B041", "#76D7C4"],
//   val: [
//     {
//       x: "Ene",
//       Euro: 2400,
//       Dolar: 2400,
//     },
//     {
//       x: "Feb",
//       Euro: 1398,
//       Dolar: 2210,
//     },
//     {
//       x: "Mar",
//       Euro: 9800,
//       Dolar: 2290,
//     },
//     {
//       x: "Abr",
//       Euro: 3908,
//       Dolar: 2000,
//     },
//     {
//       x: "May",
//       Euro: 4800,
//       Dolar: 2181,
//     },
//     {
//       x: "Jun",
//       Euro: 3800,
//       Dolar: 2500,
//     },
//     {
//       x: "Jul",
//       Euro: 4300,
//       Dolar: 2100,
//     },
//   ],
// };

const tooltipLabelFormatter = (value) => {
  return value;
};

export default function TinyLineChart({ data }) {
  const { valor } = data;
  const theme = useTheme();

  if (
    isNil(valor) ||
    isNil(valor.val) ||
    isEmpty(valor.val) ||
    isNil(valor.lines)
  ) {
    return null;
  }

  const dataVal = valor?.val;

  // X AXIS
  const isXAxisLog = valor?.scaleX === "log";
  const scaleXAxis = !isNil(valor?.scaleX) ? valor?.scaleX : "auto";

  // Y AXIS
  const isYAxisLog = valor?.scaleY === "log";
  const scaleYAxis = !isNil(valor?.scaleY) ? valor?.scaleY : "auto";

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={dataVal}>
        {valor?.showX && (
          <XAxis
            dataKey="x"
            scale={scaleXAxis}
            type={isXAxisLog ? "number" : undefined}
            domain={isXAxisLog ? [1, "dataMax"] : undefined}
            allowDataOverflow={isXAxisLog}
          />
        )}
        {valor?.showY && (
          <YAxis
            scale={scaleYAxis}
            type={isYAxisLog ? "number" : undefined}
            domain={isYAxisLog ? [1, "dataMax"] : undefined}
            allowDataOverflow={isYAxisLog}
          />
        )}
        {valor.lines.map((item, index) => {
          const lineDataKey = item;
          const lineStroke =
            !isNil(valor?.lineColors) &&
            !isEmpty(valor?.lineColors) &&
            !isNil(valor?.lineColors[index])
              ? valor?.lineColors[index]
              : theme.palette.content.mainColor;
          return (
            <Line
              key={index}
              type="monotone"
              dataKey={lineDataKey}
              stroke={lineStroke}
              strokeWidth={3}
            />
          );
        })}
        {valor?.showTooltip && (
          <Tooltip
            contentStyle={{
              color: theme.palette.text.primary,
              backgroundColor: theme.palette.background.paper,
            }}
            formatter={tooltipLabelFormatter}
          />
        )}
      </LineChart>
    </ResponsiveContainer>
  );
}
